<template>
  <v-menu bottom offset-y nudge-bottom="5" v-model="actionStatus">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-on="on"
        v-bind="attrs"
        :disabled="count <= 0 && valueComputed === 'all' && !hasError"
        class="px-2"
      >
        <v-icon class="mx-2" small>mdi-{{ content.icon }}</v-icon>
        {{ content.text }}
        <span class="font-size-h6-sm ms-2">({{ use_lang(count) }})</span>
        <v-fade-transition mode="out-in">
          <v-icon class="ms-2" key="down" v-if="!actionStatus"
            >mdi-chevron-down</v-icon
          >
          <v-icon class="ms-2" key="up" v-else>mdi-chevron-up</v-icon>
        </v-fade-transition>
      </v-btn>
    </template>

    <v-list dense>
      <template v-for="(item, i) in translatedItemsStatus">
        <v-list-item
          :key="i"
          v-if="item.value !== valueComputed"
          @click="valueComputed = item.value"
          color="primary"
          :disabled="item.disabled"
        >
          <v-list-item-icon :style="{ opacity: item.disabled ? 0.45 : 1 }">
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "headerStatusFilter",
  props: {
    value: String,
    count: Number,
    type: { type: String, default: "" },
  },
  data: () => ({
    actionStatus: false,
    itemsStatus: [
      { value: "all", key: "all_qr_codes", icon: "format-list-bulleted" },
      { value: "active", key: "active_qr_codes", icon: "heart-pulse" },
      {
        value: "deactivate",
        key: "inactive_qr_codes",
        icon: "pause-circle-outline",
      },
      { value: "near", key: "expiring_qr_codes", icon: "timer-alert-outline" },
      { value: "1", key: "expired_qr_codes", icon: "lock-clock" },
    ],
  }),
  computed: {
    ...mapState("localstorage", ["hasError"]),
    translatedItemsStatus() {
      return this.itemsStatus.map((item) => ({
        ...item,
        text: this.$t(`headerStatusFilter.${item.key}`),
      }));
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.type === "group") {
          this.updateStatusFiltergroup(val);
        } else {
          this.updateStatusFilter(val);
        }
      },
    },
    content() {
      return this.translatedItemsStatus.find(
        (item) => item.value === this.valueComputed
      );
    },
  },
  methods: {
    ...mapActions("localstorage", [
      "updateStatusFilter",
      "updateStatusFiltergroup",
    ]),
  },
};
</script>

<style scoped></style>
